<template>
	<sf-data-table
		ref="BomInfoTable"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="bomInfoCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		:customExcel="excelFunc"
		@changedPage="changedPage"
		fit="fit"
		creatable
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/BomInfo/store/helpers';

/*엑셀다운로드 시작*/
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.gridList;
		},
		bomInfoCols() {
			//그리드 컬럼
			return [
				{
					label: this.getMessage_('QWCC001115'), // 상위품번
					prop: 'ppartNo',
					headerAlign: 'center',
					width: '200px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001114'), // 상위품명
					prop: 'ppartNm',
					headerAlign: 'center',
					width: '300px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000956'), // 품번
					prop: 'partNo',
					headerAlign: 'center',
					width: '250px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000957'), // 품명
					prop: 'partNm',
					headerAlign: 'center',
					width: '300px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001802'), // SEQ_NO
					prop: 'seqNo',
					width: '150px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001111'), // 자재유형 (자재유형명)
					prop: 'partTypeNm',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000059'), // 부품유형(부품유형명)
					prop: 'partGNm',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001113'), // 납품시작일
					prop: 'aplStrtDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001112'), //납품종료일
					prop: 'aplEndDd',
					width: '130px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001120'), //USAGE
					prop: 'usage',
					minWidth: '100px',
					headerAlign: 'center',
					align: 'right'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			queryStr = objectToQuerystring({
				partNm: this.searchParams.partNm /*partNm*/,
				bomType: this.searchParams.bomType /*bomType*/
			});

			const url = `${BASE_URL}/mqy/qlty/bomInfo/v1/bomInfos/excel` + queryStr;

			const params = { url, columns: this.bomInfoCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>

<style></style>
